export const localText = {
  signOutButton: 'Sign out',
  subtitle: 'Your account does not have a role in an authorized CDH Operations Hub environment. Contact your administrator if you believe this is a mistake.',
  title: 'Not authorized',
}
